import { useSearchStoreContext } from "PFApp/search/search_context";

import { ResultsActivities } from "../results/results_activities";
import { ResultsAll } from "../results/results_all";
import { ResultsMatches } from "../results/results_matches";
import { ResultsProfiles } from "../results/results_profiles";
import { activitiesListTab, allTab, matchesTab, profilesTab } from "../tabs_constants";

export const SearchPageResults = () => {
  const {
    search: { tab }
  } = useSearchStoreContext();

  return (
    <>
      {tab === allTab && <ResultsAll />}
      {activitiesListTab.includes(tab) && <ResultsActivities />}
      {tab === profilesTab && <ResultsProfiles />}
      {tab === matchesTab && <ResultsMatches />}
    </>
  );
};
